"use client"

import { getDocument } from "pdfjs-dist"
import * as pdfjsWorker from "pdfjs-dist/build/pdf.worker.mjs"

function base64ToUint8Array(base64: string): Uint8Array {
	const raw = atob(base64)
	const uint8Array = new Uint8Array(raw.length)
	for (let i = 0; i < raw.length; i++) {
		uint8Array[i] = raw.charCodeAt(i)
	}
	return uint8Array
}

async function pdf2CombinedBase64(dataUrl: string): Promise<string> {
	const base64 = dataUrl.split(",")[1]
	if (!base64) throw new Error("Invalid data URL")

	const uint8Array = base64ToUint8Array(base64)
	const loadingTask = getDocument({
		data: uint8Array,
		worker: pdfjsWorker,
	})
	const pdf = await loadingTask.promise

	const scale = 1.5
	const pageImages: HTMLCanvasElement[] = []

	let totalHeight = 0
	let maxWidth = 0

	for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
		const page = await pdf.getPage(pageNum)
		const viewport = page.getViewport({ scale })

		const canvas = document.createElement("canvas")
		const ctx = canvas.getContext("2d")
		if (!ctx) throw new Error("Canvas context not available")

		canvas.width = viewport.width
		canvas.height = viewport.height

		await page.render({ canvas, viewport, canvasContext: ctx }).promise

		pageImages.push(canvas)
		totalHeight += viewport.height
		maxWidth = Math.max(maxWidth, viewport.width)
	}

	// Neues Canvas für alle Seiten untereinander
	const finalCanvas = document.createElement("canvas")
	finalCanvas.width = maxWidth
	finalCanvas.height = totalHeight

	const finalCtx = finalCanvas.getContext("2d")
	if (!finalCtx) throw new Error("Canvas context not available")

	let yOffset = 0
	for (const pageCanvas of pageImages) {
		finalCtx.drawImage(pageCanvas, 0, yOffset)
		yOffset += pageCanvas.height
	}

	return finalCanvas.toDataURL("image/jpeg", 0.9)
}

async function convertPDF2SingleJPG(file: File): Promise<Blob> {
	const reader = new FileReader()

	return new Promise((resolve, reject) => {
		reader.onload = () => {
			const result = reader.result
			if (typeof result !== "string") {
				reject(new Error("Failed to read file as base64 string"))
				return
			}

			pdf2CombinedBase64(result)
				.then(b64 => {
					// b64 → Blob
					fetch(b64)
						.then(res => res.blob())
						.then(blob => resolve(blob))
						.catch(reject)
				})
				.catch(reject)
		}

		reader.onerror = reject
		reader.readAsDataURL(file)
	})
}

export default convertPDF2SingleJPG
